module.exports = __webpack_public_path__ + "static/img/service.65a546.svg";